// extracted by mini-css-extract-plugin
module.exports =  {"content":"_21620d3522--content--wgY2H","title":"_21620d3522--title--Wz5xN","email":"_21620d3522--email--nbiL7"};